import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormItemModel } from 'services/models/form-builder/form-item.model';

@Component({
  selector: 'app-form-input-text',
  template: `
    <input
      type="text"
      class="form-control field-space"
      [required]="item.required"
      [placeholder]="item.placeholder ?? ''"
      [formControl]="control"
      [readonly]="readonly"
    />
  `
})
export class FormInputTextComponent {
  @Input() item!: FormItemModel;
  @Input() control!: FormControl;
  @Input() readonly: boolean = false;
} 